import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/common/knowledge-base/knowledge-base-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/journal-site/_partials/header/journal-header.tsx");
